<template>
	<div>
		<div class="welcome-login text-center">
			<!-- display the district info -->
			<img v-if="logoSrc" :src="logoSrc" :alt="districtName + ' logo'" />
			<h3 class="district-name">{{ districtName }}</h3>
			<hr />
			<!-- display any messages -->
			<div
				v-if="!!getActiveMessage.content"
				id="formFeedback"
				:class="getMessageClass"
				v-html="getActiveMessage.content"
			></div>
			<div
				id="formFeedback"
				v-if="!isTrustedClient"
			>
			<h3>Log in to continue to <br/> <small>{{clientName}}</small></h3>
			</div>
		</div>

		<form
			method="post"
			ref="form"
			@submit.prevent="validateBeforeSubmit"
			:action="endpoint"
		>
			<div v-if="hasAtleastOneSso && !parentLoginClicked">
				<button @click="parentLoginClicked = true;" type="button" class="btn btn-md btn-block btn-primary">
					Parent Login
				</button>
				<button @click="oidc()" type="button" :class="'btn btn-md btn-block ' + studentButtonColor">
					{{studentButtonText}}
				</button>
				<br/>
			</div>
			<input type="hidden" name="_csrftoken" :value="csrfToken" />
			<!-- <input type="hidden" name="redirect_uri" :value="redirectUri" /> -->
			<div
				class="form-group"
				:class="{ 'has-warning': errors.has('username') }"
				v-show="!showPin && showLogin"
			>
				<label for="username">
					Username
				</label>
				<!-- hidden and type to new-password to stop auto fill from messing with it -->
				<input
					:type="!showPin ? 'text' : 'hidden'"
					class="form-control"
					name="username"
					v-model="username"
					v-validate="'required'"
					:autocomplete="!showPin ? 'username' : 'new-password'"
				/>

				<div v-show="errors.has('username')">
					<small class="invalid-feedback">{{
						errors.first("username")
					}}</small>
				</div>
			</div>

			<div
				class="form-group"
				:class="{ 'has-warning': errors.has('password') }"
				v-show="!showPin && showLogin"
			>
				<label for="password">
					Password
				</label>
				<input
					:type="!showPin ? 'password' : 'hidden'"
					class="form-control"
					name="password"
					v-model="password"
					v-validate="'required'"
					:autocomplete="!showPin ? 'password' : 'new-password'"
				/>

				<div v-show="errors.has('password')">
					<small class="invalid-feedback">{{
						errors.first("password")
					}}</small>
				</div>
			</div>

			<!-- reCAPTCHA -->
			<!-- Captcha Dialog -->
			<div id="captchaDialog" class="modal">
				<div class="modal-content">
					<span class="close" @click="closeCaptchaDialog()">&times;</span>
					<div id="recaptcha-container">
						<iframe width="100%" height="600" style="border:none;" v-if="showCaptcha" :src="`${captchaHost}/Sapphire/captchaAPI/?captchaToken=${captchaToken}&captchaHash=${captchaHash}`" ref="myFrame" />
					</div>
				</div>
			</div>
      		

			<div style="position:absolute; left:-9999px;" v-show="!showPin && showLogin">
				<input type="text" name="username_confirm" id="username_confirm" value="" autocomplete="off">
			</div>

			<div class="hidden">
				<input type="hidden" name="recaptchaResponse" v-model="recaptchaResponse" />
			</div>

			<div
				v-if="showPin"
				class="form-group"
				:class="{ 'has-warning': errors.has('pin') }"
			>
				<label for="pin">
					PIN
				</label>
				<input
					type="password"
					class="form-control"
					name="pin"
					v-model="pin"
					maxlength="5"
					v-validate="'required'"
					autocomplete="none"
				/>

				<div v-show="errors.has('pin')">
					<small class="invalid-feedback">{{
						errors.first("pin")
					}}</small>
				</div>
			</div>

			<div class="text-right form-group" v-if="allowRememberMe" v-show="!showPin">
				<p for="rememberMe" v-if="!showPin || rememberMe">
					Remember me? 
					<input type="checkbox" name="rememberMe" v-model="rememberMe" :true-value="true" :false-value="false"/>
				</p>
			</div>

			<div v-if="showLogin">
				<a :href="entrypoint + '/security/login/?status=reset'"
					><i class="fas fa-chevron-left"></i> Go Back</a
				>
			</div>

			<div class="" v-if="showLogin">
				<button
					type="submit"
					class="btn btn-block btn-primary"
					:disabled="isFormInvalid && !isProcessing"
				>
					<span v-if="!showPin">Login</span>
					<span v-else>Continue</span>
				</button>
			</div><br/>
			
			<div class="secondary-links" v-if="!showPin">
				<a v-if="showForgotPass && showLogin" :href="entrypoint + '/forgot-password'">Forgot your password?</a> <br>
				<a :href="entrypoint + '/district-check'">Apply for a Sapphire Community Portal account</a>
			</div><br/>
			<hr/>
		</form>

		<div class="alert alert-info" v-html="registrationMessage" v-if="!showPin && isTrustedClient"></div>

		<template>
			<div class="" v-if="!showPin && isTrustedClient">
				<h3
					class="text-center"
					style="margin-bottom: 15px;"
					v-if="showRegister"
				>
					New Student Registration
				</h3>
				<a
					href="/CommunityWebPortal/Registration/login.cfm"
					class="btn btn-block btn-info"
					v-if="showRegister"
					>Register a new student</a
				>
			</div>

			<div class="go-back" v-if="showGoBack">
				<a :href="entrypoint + '/security/login/?status=logout'"
					><i class="fas fa-chevron-left"></i> Go Back</a
				>
			</div>
			
		</template>
	</div>
</template>

<script>
export default {
	props: {
		districtName: "",
		logoSrc: "",
		clientName: {
			type: String,
			required: false,
			default: "Third Party Site",
		},
		csrfToken: "",
		message: {
			type: Object,
			default: function() {
				return {
					category: "info",
					content: "Welcome!"
				};
			}
		},
		hasAtleastOneSso: {
			type: Boolean,
			default: false
		},
		azureEnabled: {
			type: Boolean,
			default: false
		},
		oktaEnabled: {
			type: Boolean,
			default: false
		},
		googleEnabled: {
			type: Boolean,
			default: false
		},
		registrationMessage: "",
		showGoBack: {
			type: Boolean,
			default: false
		},
		showPin: {
			type: Boolean,
			default: false
		},
		showForgotPass: {
			type: Boolean,
			default: false
		},
		showRegister: {
			type: Boolean,
			default: false
		},
		allowRememberMe: {
			type: Boolean,
			default: true
		},
		propRememberMe:{
			type: Boolean,
			default: false,
		},
		entrypoint: {
			type: String,
			required: true
		},
		postEndpoint: {
			type: String,
			required: true
		},
		ssoEndpoint: {
			type: String,
			required: true
		},
		redirectUri: {
			type: String, 
			required: false,
			default: ""
		},
		j_username: {
			type: String,
			required: false
		},
		j_password: {
			type: String,
			required: false
		},
		studentButtonText: {
			type: String,
			required: false,
			default:"Student Login"
		},
		studentButtonColor: {
			type: String,
			required: false,
			default:"btn-primary"
		},
		trustedClientFlg: {
			type: String,
			required: false,
			default:"N"
		},
		forceCaptcha:{
			type: String,
			required: false,
			default:"N"
		},
		captchaToken:{
			type: String,
			required: false,
			default:""
		},
		captchaHash:{
			type: String,
			required: false,
			default:""
		},
		captchaHost:{
			type: String,
			required: false,
			default:"https://sapphire.k12system.com"
		},

	},
	data() {
		return {
			username: "",
			password: "",
			pin: "",
			rememberMe: false,
			endpoint: this.postEndpoint,
			parentLoginClicked: false,
			recaptchaResponse:"",
			isProcessing:false
		};
	},
	computed: {
		showCaptcha(){
			return this.forceCaptcha == 'Y' && (!this.showPin && this.showLogin) && this.captchaToken.length > 0;
		},
		isTrustedClient(){
			return this.trustedClientFlg == 'Y';
		},
		showLogin(){
			return !this.hasAtleastOneSso || this.parentLoginClicked || this.showPin;
		},
		isFormInvalid() {
			return Object.keys(this.fields).some(
				key => this.fields[key].invalid
			);
		},
		isFormTouched() {
			return Object.keys(this.fields).some(
				key => this.fields[key].touched
			);
		},
		getMessageClass() {
			return "alert alert-" + this.getActiveMessage.category;
		},
		getActiveMessage() {
			if (this.showPin) {
				return {
					category: "warning",
					content: "Please enter your PIN to continue."
				};
			} else if (this.isFormInvalid && this.isFormTouched) {
				return {
					category: "warning",
					content: "Some required fields are missing!"
				};
			} else {
				return this.message;
			}
		}
	},
	methods: {
		oidc(){
			this.endpoint = this.ssoEndpoint;
			setTimeout(()=>{
				this.$refs.form.submit();
			},1000);
			
		},
		validateBeforeSubmit() {
			if(this.isProcessing){
				return false;
			}
			this.isProcessing = true;
			setTimeout(2000,()=>{
				this.isProcessing = false;
			})
			this.$validator.validateAll().then(result => {
				if (result) {
					if(!this.showCaptcha){
						this.$refs.form.submit();
						return;
					}
					this.openCaptchaDialog()
				}
			});
		},
		openCaptchaDialog() {
			// Display the modal
			document.getElementById('captchaDialog').style.display = "block";
			
		},
		closeCaptchaDialog() {
			document.getElementById('captchaDialog').style.display = "none";
		}
	},
	mounted() {
		if (this.showPin) {
			this.username = this.j_username;
			this.password = this.j_password;
			this.rememberMe = this.propRememberMe;
			
		}

		console.log('mounted called')
		this.$nextTick(()=> {
			if(this.showCaptcha){
				/* Load frame */
				const root = this;
				window.addEventListener('message', function(event) {
					// Check the origin of the message for security
					if (event.origin !== '') {
						//return; // Ignore messages from untrusted origins
					}

					// Process the message
					if (!!event.data && typeof event.data == 'string' && event.data.substring(0,8) == "captcha:") {
						console.log(event.data);
						
						root.recaptchaResponse = event.data.replace("captcha:", "");
						root.$validator.validateAll().then(result => {
							root.$refs.form.submit();
							return;
						});
					}
				});
			}
		});
	}
};
</script>

<style scoped>

/* Basic modal styling */
.modal {
    position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%,-50%);
	width: 50vw;
	min-height: 50vh;
	z-index: 99;
	box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
	display: none;
	padding: 15px;
}

.modal-content {
    position: relative;
  	min-height: 40vh;

}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

</style>